import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase/app';

import App from './App';

const firebaseConfig = {
    apiKey: "AIzaSyDWEZ8iF1o3ScIdDjhexoerkWcm_-6pWZA",
    authDomain: "vpn---virtual-private-number.firebaseapp.com",
    databaseURL: "https://vpn---virtual-private-number.firebaseio.com",
    projectId: "vpn---virtual-private-number",
    storageBucket: "vpn---virtual-private-number.appspot.com",
    messagingSenderId: "653236970735",
    appId: "1:653236970735:web:9803c992f2ca38c7fa271a"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById('root'));
